import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'profile',
    lazy: async () => ({ Component: (await import('./ProfilePage')).ProfilePage }),
  },
];
